var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCard1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "51px",
    viewBox: "0 0 45 51",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 15") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Project-Editor-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#4A4A4A",
    strokeWidth: 3,
    fill: "#FFFFFF",
    x: -1.77635684e-14,
    y: 0,
    width: 40.6587302,
    height: 47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6922399,5.69929453 L28.6922399,17.5943563 L11.6992945,17.5943563 L11.6992945,5.69929453 L28.6922399,5.69929453 Z M30.3915344,4 L10,4 L10,19.2936508 L30.3915344,19.2936508 L30.3915344,4 Z M18.4964727,15.8542787 C17.1786698,15.6291221 15.9475309,14.4820983 15.9475309,13.0997222 L15.9475309,10.9127302 L18.4964727,13.2246204 L18.4964727,15.8542787 Z M20.1957672,14.0674705 L20.1957672,11.6765631 C22.5271993,11.2389947 22.6571953,8.7078955 21.9477399,7.39858907 L20.7820238,8.68070679 L19.7768911,7.39858907 L18.8363316,8.68070679 L17.6366296,7.39858907 C16.946716,8.67221032 16.9976949,11.2355961 19.3461199,11.6765631 L19.3461199,15.8950617 L20.6112447,15.8950617 C22.1550538,15.8950617 23.5943563,14.6435313 23.5943563,13.0988726 L23.5943563,10.9118805 L20.1957672,14.0674705 Z",
    id: "Shape",
    fill: "#4A4A4A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(4.000000, 25.000000)",
    fill: "#4A4A4A"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 19,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-14",
    x: 0,
    y: 7.5,
    width: 31,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-15",
    x: 0.238095238,
    y: 13.5,
    width: 31,
    height: 3
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1);
export default __webpack_public_path__ + "static/media/Card 1.a54348b5.svg";
export { ForwardRef as ReactComponent };